<template>
  <header class="sticky top-0 z-50 w-full border-b border-slate-800 bg-slate-900/80 backdrop-blur supports-[backdrop-filter]:bg-slate-900/60">
    <div class="container mx-auto flex h-16 items-center justify-between px-4">
      <div class="flex items-center gap-2">
        <router-link to="/" class="flex items-center space-x-2">
          <span class="text-xl font-bold bg-gradient-to-r from-primary-400 to-primary-600 bg-clip-text text-transparent">
            CodeCopy
          </span>
        </router-link>
      </div>

      <nav class="hidden md:flex items-center gap-6 text-sm font-medium">
        <router-link to="/" class="text-slate-300 hover:text-white transition-colors">Home</router-link>
        <router-link to="/ai" class="text-slate-300 hover:text-white transition-colors">AI Tools</router-link>
        <router-link to="/stacks" class="text-slate-300 hover:text-white transition-colors">Stacks</router-link>
        <router-link to="/about" class="text-slate-300 hover:text-white transition-colors">About</router-link>
        <a href="https://algoquest.dev" target="_blank" class="text-slate-300 hover:text-white transition-colors flex items-center gap-1">
          AlgoQuest
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
        </a>
      </nav>
      
      <!-- Mobile Menu Button (Placeholder) -->
      <button class="md:hidden text-slate-300 hover:text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>
      </button>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppHeader',
});
</script>

<style scoped>
.router-link-exact-active {
  @apply text-white font-semibold;
}
</style>
